import SalaryTable from "../components/Salary/SalaryTable";

const Salary = () => {
    return <SalaryTable />;
};

export default Salary;
